'use client'

import { useEffect } from 'react'

/**
 * Último recurso do App Router: só é usado quando o ROOT layout (ou template)
 * falha, então substitui `app/layout.tsx` por inteiro — precisa declarar seu
 * próprio `<html>`/`<body>` e não pode depender de nenhum provider, tema ou
 * componente do shell (eles podem ser a própria causa da falha). Por isso
 * usa apenas estilos inline/utilitários simples, sem importar `Header`,
 * `ThemeToggle` ou qualquer componente que dependa de contexto.
 *
 * Nunca expõe `error.message` na tela — só o `error.digest`, quando existe,
 * como referência de suporte.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html lang="pt-BR">
      <body
        style={{
          margin: 0,
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          background: '#f2f4f8',
          color: '#111827',
        }}
      >
        <div style={{ maxWidth: '360px', textAlign: 'center' }}>
          <p style={{ fontSize: '15px', fontWeight: 600, margin: 0 }}>Algo deu errado</p>
          <p style={{ fontSize: '13px', color: '#4b5563', marginTop: '8px', marginBottom: 0 }}>
            Não foi possível carregar o aplicativo. Tente novamente em instantes.
          </p>
          {error.digest && (
            <p style={{ fontSize: '11px', color: '#8b8b86', marginTop: '8px' }}>
              Código de referência: {error.digest}
            </p>
          )}
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: '20px',
              borderRadius: '9px',
              background: '#2445d8',
              color: '#ffffff',
              border: 'none',
              padding: '10px 18px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Tentar novamente
          </button>
        </div>
      </body>
    </html>
  )
}
